export default __webpack_public_path__ + "static/media/card4.15d48250.png";